import React from 'react';
import { FALLBACK_VALUE } from './constants';

/**
 * Safely gets a renderable output of most given values.
 */
const getRenderable = (child, fallbackProps = {}, props = {}) => {
    let rendered = child;
    const mergedProps = Object.assign({}, fallbackProps, rendered ? rendered.props : {}, props);

    // React Elements
    if (React.isValidElement(rendered)) {
        return React.cloneElement(rendered, mergedProps);
    }

    // Stateless function constructors or render-props
    if (typeof child === 'function') {
        rendered = child(mergedProps);
    }

    // Falsey values are not valid React nodes
    if (['undefined', 'boolean'].includes(typeof rendered)) {
        return FALLBACK_VALUE;
    }

    // All other valid React nodes (strings, integers, etc.)
    return rendered;
};

export default getRenderable;
